// extracted by mini-css-extract-plugin
export default {"resizer":"ColumnResizer_resizer__6Byg+"};